<template>
  <div class="showker-header">
    <!-- 系统公告 -->
    <section class="showker-notice">
      <div class="showker-notice__list">
        <el-carousel
          :autoplay="true"
          :interval="5000"
          height="34px"
          direction="vertical"
          indicator-position="none"
        >
          <el-carousel-item
            v-for="(item, index) in noticeList"
            :key="index"
          >
            <div
              class="showker-notice__list-inner ellipsis"
              v-html="item"
            ></div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <span
        class="link-text"
        @click="openNoticeMore"
      >查看全部<i class="eqf-right"></i></span>
    </section>

    <div class="panel-wrapper">
      <!-- 账户信息 -->
      <section class="panel account-info">
        <div class="head">
          <div class="avatar">
            <img
              v-if="!!headImg"
              :src="headImg"
            >
            <span
              v-else
              class="eqf-user-f"
            ></span>
          </div>
          <div class="title-hd">
            <div
              class="title ellipsis"
            >
              {{ userInfo.name }}
            </div>
            <a
              class="eqf-pen-f"
              @click="editUser"
            ></a>
          </div>
        </div>
        <div class="showker-link">
          <a
            class="link-text"
            @click="goMyShop(userInfo.id)"
          >
            <i class="eqf-mall-f"></i>小店</a>
          <a
            class="link-text"
            @click="goShowkerSchool"
          >
            <i class="eqf-school"></i>知识库</a>
        </div>
      </section>

      <!-- 本月收益 -->
      <section class="panel account-profit">
        <div class="panel-header">
          <div class="panel-title">
            {{ monthIncome.viewType === 2 ? '上月' : '本月' }}收益
            <el-tooltip
              placement="top"
            >
              <div slot="content">
                指当月1日到查询日前一天的累计收益（不包含查询日当天收益），每日11时更新完全部数据。
              </div>
              <i class="eqf-why-l"></i>
            </el-tooltip>
          </div>
          <div class="panel-link">
            <router-link
              class="search link-text"
              to="/transactionSearch"
            >
              交易查询<i class="eqf-right"></i>
            </router-link>
          </div>
        </div>
        <div class="panel-content">
          <div class="total-income ellipsis">
            <span>+{{ totalIncome }}</span><em>元</em>
          </div>
          <div
            class="income"
          >
            <div class="income-item">
              <div class="income-item__label">
                <span>订单收益</span>
                <el-tooltip
                  effect="dark"
                  placement="top-start"
                >
                  <div slot="content">
                    为用户单次付费购买模板的分成，已实时到账至“可提现收益”账户。
                  </div>
                  <i class="eqf-why-l"></i>
                </el-tooltip>
              </div>
              <div class="income-item__value ellipsis">
                {{ templateIncome }}
              </div>
              <div class="income-item__unit">
                元
              </div>
            </div>
            <div class="income-item">
              <div class="income-item__label">
                分销收益
              </div>
              <div class="income-item__value ellipsis">
                {{ distributeInconme }}
              </div>
              <div class="income-item__unit">
                元
              </div>
            </div>
            <div class="income-item">
              <div class="income-item__label">
                <span>会员收益(预测)</span>
                <el-tooltip
                  effect="dark"
                  placement="top-start"
                >
                  <div slot="content">
                    为预测数据，于次月初到账至“可提现收益”账户，请以实际到账为准。
                  </div>
                  <i class="eqf-why-l"></i>
                </el-tooltip>
              </div>
              <div class="income-item__value ellipsis">
                {{ memberIncome }}
              </div>
              <div class="income-item__unit">
                元
              </div>
            </div>
            <div class="income-item">
              <div class="income-item__label">
                <span>奖励收益</span>
                <el-tooltip
                  effect="dark"
                  placement="top-start"
                >
                  <div slot="content">
                    包含任务奖励收益和模板高质奖励收入。
                  </div>
                  <i class="eqf-why-l"></i>
                </el-tooltip>
              </div>
              <div class="income-item__value ellipsis">
                {{ taskRewardIncome }}
              </div>
              <div class="income-item__unit">
                元
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 可提现收益 -->
      <section class="panel account-balance">
        <div class="balance">
          <div class="balance-item">
            <div class="panel-title">
              可提现收益
              <el-tooltip
                effect="dark"
                placement="top-start"
              >
                <div slot="content">
                  该收益为秀客可提现总收益，包括模板相关收益、会员相关收益、分销收益及其他补贴收益。其中，上月会员（使用/下载）收益指上月实际到账的会员收益，即上上月会员收益。以上数据每月1日11时更新。
                </div>
                <i class="eqf-why-l"></i>
              </el-tooltip>
            </div>
            <div class="balance-item__value ellipsis">
              {{ withdrawInfo.totalAmount ? withdrawInfo.totalAmount : 0 }}<em>元</em>
            </div>
          </div>
          <div class="balance-item">
            <div class="panel-title">
              提现额度
            </div>
            <div class="balance-item__value ellipsis">
              {{ withdrawInfo.limitCash ? withdrawInfo.limitCash : 0 }}<em>元</em>
            </div>
          </div>
        </div>
        <div class="widthdraw-btn__wrapper">
          <el-button
            :disabled="!canWithdraw"
            type="primary"
            size="small"
            @click="withdraw"
          >
            申请提现
          </el-button>
        </div>
        <div class="search-btn__wrapper">
          <router-link
            :to="{name:'transactionSearch',query:{tab:'WithdrawalRecords'}}"
            class="search link-text"
          >
            提现记录<i class="eqf-right"></i>
          </router-link>
        </div>
      </section>

      <!-- 任务中心 -->
      <section class="panel account-task">
        <div class="panel-header">
          <div class="panel-title">
            任务中心
          </div>
        </div>
        <div class="panel-content">
          <div class="task-list">
            <div
              class="task-list__item"
              @click="moveTo('TaskCenter', { viewCollectableTask: true })"
            >
              <div class="task-list__item-label">
                可领任务
              </div>
              <div class="task-list__item-value ellipsis">
                {{ currentTaskNum }}
              </div>
              <div class="task-list__item-link">
                <span class="link-text">
                  查看详情<i class="eqf-right"></i>
                </span>
              </div>
              <div
                v-if="hasNewTask"
                class="has-new-task"
              ></div>
            </div>
            <div
              class="task-list__item"
              @click="moveTo('TaskList')"
            >
              <div class="task-list__item-label">
                我的任务
              </div>
              <div class="task-list__item-value ellipsis">
                {{ myTaskNum }}
              </div>
              <div class="task-list__item-link">
                <span class="link-text">
                  查看详情<i class="eqf-right"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 弹窗 -->
    <withdraw-dialog
      :show="withdrawShow"
      @hide="withdrawShow = false"
    />
    <withdraw-company-dialog
      :show="withdrawCompanyShow"
      @hide="withdrawCompanyShow = false"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import WithdrawDialog from './WithdrawDialog'
import WithdrawCompanyDialog from './WithdrawCompanyDialog'
import {
  judgeCash,
  getCashStatus,
  getMonthIncome,
  getShowkerTaskCount
} from 'api/showker'
import { host } from 'src/config/env'
export default {
  name: 'ShowkerHeader',
  components: {
    WithdrawDialog,
    WithdrawCompanyDialog
  },
  data() {
    return {
      /**
       * 提现弹窗
       */
      withdrawShow: false,
      withdrawCompanyShow: false,
      requestLock: false,
      monthIncome: {},
      hasNewTask: false,
      currentTaskNum: 0,
      myTaskNum: 0
    }
  },
  computed: {
    ...mapState('user', [
      'userInfo',
      'financeInfo',
      'statistics',
      'showkerInfo',
      'withdrawInfo',
      'canWithdraw',
      'notifications'
    ]),
    headImg() {
      return this.userInfo.headImg
    },
    // 订单收益
    templateIncome() {
      const { lastTemplateUseIncome = 0, lastTemplateDownloadIncome = 0 } = this.monthIncome
      const result = lastTemplateUseIncome + lastTemplateDownloadIncome
      return +result.toFixed(2)
    },
    // 分销收益
    distributeInconme() {
      const { lastDistributeInconme = 0 } = this.monthIncome
      return +lastDistributeInconme.toFixed(2)
    },
    // 会员收益
    memberIncome() {
      const { lastMemberUsedIncome = 0, lastMemberDownlocadIncome = 0 } = this.monthIncome
      const result = lastMemberUsedIncome + lastMemberDownlocadIncome
      return +result.toFixed(2)
    },
    // 任务收益
    taskRewardIncome() {
      const { taskRewardIncome = 0 } = this.monthIncome
      return +taskRewardIncome.toFixed(2)
    },
    totalIncome() {
      const result = this.templateIncome + this.distributeInconme + this.memberIncome + this.taskRewardIncome
      return +result.toFixed(2)
    },
    noticeList() {
      return this.notifications.map(v => v.content)
    }
  },
  created() {
    this.getMonthIncome()
    this.getShowkerTaskCount()
  },
  methods: {
    async getMonthIncome() {
      try {
        const params = {
          showkerId: this.userInfo.id,
          startDate: this.$moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          endDate: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        }
        const { data } = await getMonthIncome(params)

        this.monthIncome = data.obj || {}
      } catch (e) {
        console.log(e, 'err')
      }
    },
    async getShowkerTaskCount() {
      try {
        const { data } = await getShowkerTaskCount({ showkerId: this.userInfo.id })
        const { availableTaskCount, myTaskCount } = data.obj

        this.currentTaskNum = availableTaskCount
        this.myTaskNum = myTaskCount

        // 设置小红点
        if (localStorage) {
          const availableTaskNum = localStorage.getItem('AVAILABLE_TASK_NUM') || 0
          if (+availableTaskNum !== this.currentTaskNum) {
            this.hasNewTask = true
          } else {
            this.hasNewTask = false
          }
          localStorage.setItem('AVAILABLE_TASK_NUM', this.currentTaskNum)
        }
      } catch (e) {
        console.log(e, 'err')
      }
    },
    openNoticeMore() {
      window.open(Vue.env.host.base + '/eip/message', '_blank')
    },
    withdraw() {
      if (this.requestLock) return
      this.requestLock = true
      judgeCash().then(res => {
        res = res.data
        // 日期不在5-20号
        switch (res.code) {
          case 990035:
            this.$alert(
              {
                title: '提示',
                message: '当前不支持提现<br><p class="text-small">请于每月<span class="text-color-blue">5-20日</span>期间申请提现。</p>',
                dangerouslyUseHTMLString: true,
                confirmButtonText: '知道了',
                type: 'info'
              }
            )
            this.requestLock = false
            break
          case 800014:
            // 您本月的提现次数已满
            this.$alert(
              {
                title: '提示',
                message: '您本月的提现次数已满<br><p class="text-small">每次仅支持提现一次，请于下月<span class="text-color-blue">5-20日</span>期间申请提现</p>',
                dangerouslyUseHTMLString: true,
                confirmButtonText: '知道了',
                type: 'info'
              }
            )
            this.requestLock = false
            break
          case 800015:
            this.$alert({
              title: '提示',
              message: '提现金额小于100元，不支持提现',
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了',
              type: 'info'
            })
            this.requestLock = false
            break
          case 200:
            this.checkStatus()
            break
        }
      })
    },
    checkStatus() {
      getCashStatus().then(res => {
        res = res.data
        this.requestLock = false
        if (res.code !== 200) {
          return
        }
        switch (parseInt(res.map.certStatus)) {
          case 0:
            this.$confirm({
              title: '提示',
              message: '该账号尚未认证无法提现，请先进行账号认证',
              confirmButtonText: '认证账号',
              cancelButtonText: '取消提现',
              howClose: false,
              type: 'warning',
              showClose: false,
              closeOnClickModal: false
            }).then(() => {
              window.location.href = `${host.base}/usercenter/advanced/index`
            })
            break
          case 1:
            if (parseInt(res.map.certType) === 1) {
              this.withdrawCompanyShow = true
            } else {
              this.withdrawShow = true
            }
            break
          case 2:
            this.$alert(
              {
                title: '提示',
                message: '秀客认证审核中，请审核通过后再提现<br><p class="text-small">请耐心等待，审核结果将会在<span style=\'color: red;\'>3个工作日</span>内以站内信形式发送</p>',
                dangerouslyUseHTMLString: true,
                confirmButtonText: '知道了',
                type: 'warning'
              })
            break
          case 3:
            this.$confirm({
              title: '提示',
              message: '该账号审核拒绝，请重新进行认证',
              confirmButtonText: '认证',
              cancelButtonText: '取消',
              howClose: false,
              type: 'info',
              showClose: false,
              closeOnClickModal: false
            }).then(() => {
              window.location.href = `${host.base}/showker/cert`
            })
            break
        }
      })
    },
    // 编辑用户信息
    editUser() {
      const { href } = this.$router.resolve({
        name: 'editShowker'
      })
      window.location.href = href
    },
    goMyShop(id) {
      window.open(`${host.showker}/pc?showkerId=${id}`, '_blank')
    },
    goShowkerSchool() {
      window.open('http://showker.eqxiuzhan.com', '_blank')
    },
    moveTo(name, params = {}) {
      this.$router.push({ name, params })
    }
  }
}
</script>

<style lang="scss" scoped>
.showker-header {
  position: relative;

  a:hover {
    color: #1261FF;
  }

  .panel-wrapper {
    display: flex;
    height: 180px;
  }

  .panel {
    position: relative;
    background-color: #fff;
    height: 100%;
    border-radius: 4px;
    padding: 22px 24px 24px 24px;
    border: 1px solid #E6EBED;

    &:not(:first-child) {
      margin-left: 16px;
    }

    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
    }

    &-title {
      display: inline-flex;
      align-items: center;
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      line-height: 16px;
    }
  }

  .link-text {
    display: inline-flex;
    align-items: center;
    color: #666;
    font-size: 12px;
    line-height: 14px;
    cursor: pointer;
    &:hover{
      color: #1261FF;
    }

    i {
      font-size: 14px;
      margin-bottom: -1px;
    }
  }

  .eqf-right {
    font-size: 14px;
  }

  .eqf-why-l {
    font-size: 14px;
    margin-left: 4px;
    color: #999;

    &:hover {
      color: #666;
    }
  }

  .showker-notice {
    padding: 0 16px;
    background-color: #E7EFFF;
    height: 34px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    margin-bottom: 32px;

    &__list {
      flex: 1;
      margin-right: 100px;

      &-inner {
        line-height: 34px;
        font-size: 12px;
        color: #333;
      }
    }

    &__link {
      font-size: 12px;
    }
  }

  .account-info {
    flex: 0.7;
    min-width: 175px;
    max-width: 360px;
    .head {
      position: relative;
      text-align: center;
      .avatar {
        img {
          position: relative;
          width: 44px;
          height: 44px;
          border-radius: 100%;
        }
        span {
          width: 44px;
          height: 44px;
          border-radius: 100%;
          font-size: 44px;
        }
      }
    }
    .title-hd {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 16px;
      a {
        font-size: 18px;
        margin-left: 4px;
        vertical-align: top;
      }
      .title {
        display: inline-block;
        max-width: 105px;
        font-size: 18px;
        line-height: 18px;
        font-weight: bold;
      }
    }
    .showker-link {
      max-width: 200px;
      margin: 28px auto 0 auto;
      display: flex;
      justify-content: space-around;

      .link-text {
        color: #666;
        font-size: 14px;

        &:hover{
          color: #1261FF;
        }
      }
    }
    .eqf-mall-f,
    .eqf-school {
      margin-right: 4px;
      font-size: 16px;
      color: #1261FF;
    }
  }

  .account-profit {
    flex: 1;

    .total-income {
      display: flex;
      align-items: center;
      color: #FF5448;
      height: 18px;
      line-height: 18px;
      font-size: 18px;
      font-weight: bold;

      em {
        font-size: 12px;
        margin-left: 4px;
        font-weight: normal;
      }
    }

    .income {
      margin-top: 14px;
      .income-item {
        height: 14px;
        line-height: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: #666;

        &:not(:first-child) {
          margin-top: 8px;
        }

        &__label {
          display: inline-flex;
          align-items: center;
        }

        &__value {
          flex: 1;
          text-align: right;
          color: #333;
          font-weight: bold;
        }

        &__unit {
          margin-left: 4px;
        }
      }
    }
  }

  .account-balance {
    flex: 1;
    min-width: 240px;

    .balance {
      display: flex;

      &-item {
        flex: 1;

        &:first-child {
          min-width: 100px;
        }

        &:not(:first-child) {
          margin-left: 23px;
        }

        &__value {
          display: flex;
          align-items: center;
          margin-top: 12px;
          color: #1261FF;
          font-size: 16px;
          font-weight: bold;
          line-height: 18px;

          em{
            font-size: 12px;
            margin-left: 4px;
            font-weight: normal;
          }
        }
      }
    }

    .widthdraw-btn__wrapper {
      margin-top: 24px;
    }

    .search-btn__wrapper {
      margin-top: 16px;
    }
  }

  .account-task {
    flex: 1;
    min-width: 246px;

    .task-list {
      margin-top: 12px;
      width: 100%;
      display: flex;
      justify-content: space-between;

      &__item {
        flex: 1;
        height: 106px;
        // border: 1px solid #E6EBED;
        background: #F5F7FA;
        border-radius: 4px;
        padding: 14px 10px 10px 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        // align-items: center;
        position: relative;
        cursor: pointer;

        &:not(:first-child) {
          margin-left: 12px;
        }

        &:hover {
          .task-list__item-link .link-text {
            color: #1261FF;
          }
        }

        &-label {
          margin-bottom: 12px;
          font-size: 12px;
          line-height: 12px;
          color: #333;
        }

        &-value {
          color: #1261FF;
          font-size: 20px;
          line-height: 20px;
          font-weight: bold;
          margin-bottom: 20px;
        }

        .has-new-task {
          width: 10px;
          height: 10px;
          background-color: #FF5448;
          border-radius: 50%;
          position: absolute;
          right: -3px;
          top: -3px;
        }
      }
    }
  }
}
</style>
